import { FC } from 'react';
import './BarChartLabels.scss';
import { BarChartEntry } from '../BarChart/BarChart.types';
import messages from '../../locales/messages';
import { FormattedMessage } from 'react-intl';

interface Props {
  entries: BarChartEntry[];
}

export const BarChartLabels: FC<Props> = ({ entries }) => {
  return (
    <div className="bar-chart-labels">
      {entries.map((entry, i) => {
        return (
          <div className="bar-chart-labels__label" key={i}>
            <FormattedMessage {...messages[entry.label]} />
          </div>
        );
      })}
    </div>
  );
};
